import 'iscroll';
import { CoordinatesPosition, Room } from './models';
import { getCenterPoint, getDistanceBetweenPoints, getMultiTouchXY } from './functions';

export class IScrollPinchInOutAddon {
  //TODO:いったん仮に型を追加しているのでのちにdeclareなどでちゃんと型を追加する。
  private _iScrollInstance?: IScroll & {
    scrollBy: (x: number, y: number, time?: number, easing?: Function) => void;
  };
  private _element?: HTMLElement;
  private _roomSize?: Room['roomSize'];

  /**
   * ピンチイン・アウト開始時の点
   */
  private startPositions?: [CoordinatesPosition, CoordinatesPosition];
  private startScale?: number = 0;

  /**
   * TouchMove中において、前回発生したTouchMoveイベント時の座標（2本指の中点の座標）
   */
  private previousCenterPosition?: CoordinatesPosition;

  /**
   * 2本指以上で操作中かどうか。
   */
  private doubleTouched = false;

  get isInitialized() {
    return this._iScrollInstance && this._element && this._roomSize;
  }

  constructor() {}

  registerIScrollInstance(instance: IScroll, element: HTMLElement, roomSize: Room['roomSize']) {
    if (this.isInitialized) this.unregisterIScrollInstance();
    this._element = element;
    this._iScrollInstance = instance as any;
    this._roomSize = roomSize;
    this._element.addEventListener('touchstart', this.onTouchStart);
    this._element.addEventListener('touchmove', this.onTouchMove);
    this._element.addEventListener('touchend', this.onTouchEnd);
  }

  unregisterIScrollInstance() {
    if (!this.isInitialized) throw new Error('IScrollInstanceが登録されていないため、登録解除できませんでした。');
    this._element?.removeEventListener('touchstart', this.onTouchStart);
    this._element?.removeEventListener('touchmove', this.onTouchMove);
    this._element?.removeEventListener('touchend', this.onTouchEnd);
    this._iScrollInstance = undefined;
    this._element = undefined;
    this._roomSize = undefined;
  }

  private onTouchStart = (event: TouchEvent) => {
    this.doubleTouched = false;
    if (event.touches.length == 2 && this._iScrollInstance) {
      this.startPositions = getMultiTouchXY(event) as [CoordinatesPosition, CoordinatesPosition];
      this.startScale = this._iScrollInstance.scale;
      this.doubleTouched = true;
      this._iScrollInstance.disable(); //タッチでズーム中は移動してしまわないように
    }
  };
  private onTouchMove = (event: TouchEvent) => {
    event.preventDefault();
    requestAnimationFrame(() => {
      if (!this._iScrollInstance || event.touches.length < 2 || !this.startPositions) return;
      const currentPositions = getMultiTouchXY(event) as [CoordinatesPosition, CoordinatesPosition];
      const startDistance = getDistanceBetweenPoints(...this.startPositions);
      const currentDistance = getDistanceBetweenPoints(...currentPositions);
      const scale = this.startScale! * (currentDistance / startDistance);
      const currentCenterPoint = getCenterPoint(currentPositions);
      const startCenterPoint = getCenterPoint(this.startPositions);
      this._iScrollInstance.zoom(scale, startCenterPoint.x, startCenterPoint.y, 0);

      //ズーム中にも移動を可能にする。
      if (
        this.previousCenterPosition &&
        getDistanceBetweenPoints(currentCenterPoint, this.previousCenterPosition) > 1.5 //1.5より差が大きい時のみズーム中のスクロールを可能。2本指で指を画面に乗せているだけでも手の若干の震えで1.0~1.4ほど動いているため、震えで移動しないように。
      ) {
        this._iScrollInstance.scrollBy(
          currentCenterPoint.x - this.previousCenterPosition.x,
          currentCenterPoint.y - this.previousCenterPosition.y,
          0,
        );
      }
      this.previousCenterPosition = currentCenterPoint;
    });
  };

  private onTouchEnd = (event: TouchEvent) => {
    this.startPositions = undefined;
    this.startScale = undefined;
    this.previousCenterPosition = undefined;
    //50ms遅らせてenableする。ピンチイン、アウト後に荒ぶるのを防ぐため。
    //(原因の仮設)勢いよくピンチアウトしてTouchEndした直後も実際は若干画面に指が触れていて、それがスクロールしていると判定されている。
    setTimeout(() => {
      this._iScrollInstance?.enable();
      requestAnimationFrame(() => {
        if (this.doubleTouched) this.repositionMap();
      });
    }, 50);
  };

  /**
   * 範囲外に移動している場合に範囲内に戻す
   * @returns
   */
  private repositionMap = () => {
    if (!this.isInitialized) return;
    const [imgW, imgH] = [this._roomSize!.width, this._roomSize!.height].map((s) => s * this._iScrollInstance!.scale);
    const [viewW, viewH] = [this._element!.clientWidth, this._element!.clientHeight];
    const position: CoordinatesPosition = {
      x: this._iScrollInstance!.x,
      y: this._iScrollInstance!.y,
    };
    //左右方向の範囲チェック
    if (-position.x < 0) {
      //左に行き過ぎている。
      position.x = 0;
    } else if (-position.x > imgW - viewW) {
      //右に行き過ぎている
      position.x = -(imgW - viewW);
    }
    //上下方向の範囲チェック
    if (-position.y < 0) {
      //上に行き過ぎている
      position.y = 0;
    } else if (-position.y > imgH - viewH) {
      //下に行き過ぎている
      position.y = -(imgH - viewH);
    }
    this._iScrollInstance!.scrollTo(position.x, position.y, 300);
  };
}
